import { createContext, useContext, useState, useEffect, useCallback } from "react";
import translations from "@/lib/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("sousa-lang") || null;
  });

  const t = lang ? translations[lang] : translations.en;

  const changeLanguage = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem("sousa-lang", newLang);
  }, []);

  useEffect(() => {
    if (lang) {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
};
